import { TabContext, TabList } from '@mui/lab';
import { styled, Tab } from '@mui/material';
import { Box } from '@mui/system';
import FlexBox from 'components/flexbox/FlexBox';
import { H5 } from 'components/Typography';

const Wrapper = styled(Box)(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
}));
const TabListWrapper = styled(TabList)(({ theme }) => ({
    [theme.breakpoints.down(727)]: {
        order: 3,
    },
}));

const HeadingArea = ({ value, data, changeTab }) => {
    const header = [
        { 
            name: 'All', 
            value: 'all',
            color: '#424242',
            bgColor: '#eeeeee',
         },
        { 
            name: 'New', 
            value: 'new',
            color: '#0d47a1',
            bgColor: '#e3f2fd',
         },
        { 
            name: 'Submitted', 
            value: 'submitted',
            color: '#ef6c00',
            bgColor: '#fff3e0',
         },
        { 
            name: 'Invoiced', 
            value: 'invoiced',
            color: '#0d47a1',
            bgColor: '#e3f2fd',
         },
        { 
            name: 'GL Uploaded', 
            value: 'gl_uploaded',
            color: '#0d47a1',
            bgColor: '#e3f2fd',
         },
        { 
            name: 'GL Approved', 
            value: 'gl_approved',
            color: '#1b5e20',
            bgColor: '#e8f5e9',
         },
        { 
            name: 'Paid', 
            value: 'paid',
            color: '#1b5e20',
            bgColor: '#e8f5e9',
         },
        { 
            name: 'Rejected', 
            value: 'rejected',
            color: '#c62828',
            bgColor: '#ffebee',
         },
    ];

    function countByStatus(targetStatus) {
        if (targetStatus === 'all') {
            return data.length;
        }

        return data.reduce((count, item) => {
            return count + (item.status.value === targetStatus ? 1 : 0);
        }, 0);
    }
    return (
        <Wrapper gap={1}>
            <FlexBox alignItems="center">
                <H5>Registration Group</H5>
            </FlexBox>

            <TabContext value={value}>
                <TabListWrapper variant="scrollable" onChange={changeTab}>
                    {header.map((item, index) => (
                        <Tab
                            key={index}
                            disableRipple
                            label={
                                item.name +
                                ' (' +
                                countByStatus(item.value) +
                                ')'
                            }
                            value={item.value}
                            sx={{
                                color: item?.color || '#424242',
                                backgroundColor: item?.bgColor || '#eeeeee',
                                borderRadius: 1,
                                textTransform: 'none',
                                fontWeight: 600,
                                minHeight: 32,
                                marginRight: 0.5,
                                '&.Mui-selected': {
                                    color: item?.color || '#424242',
                                    backgroundColor: item?.bgColor || '#eeeeee',
                                },
                            }}
                        />
                    ))}
                </TabListWrapper>
            </TabContext>
        </Wrapper>
    );
};

export default HeadingArea;
